<!--
 * @Description: 资金管理结算记录
 * @Author: xu wei
 * @Date: 2020-02-27 17:43:13
 * @LastEditTime: 2020-09-01 15:39:27
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>资金管理</el-breadcrumb-item>
        <el-breadcrumb-item>结算记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>起始时间：</span>
          <!-- <el-date-picker style="width:338px;" v-model="time" size="small" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker> -->
          <el-date-picker style="width:190px;" v-model="time1" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
          </el-date-picker> <span style="font-size:14px;">至 </span>
          <el-date-picker style="width:190px;" v-model="time2" size="small" default-time="23:59:59" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
          </el-date-picker>
        </li>
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" type="number" v-model="tenantId" @input="tenantId=intNumber(tenantId)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>余额：</span>
          <span>
            <el-input style="width:100px;" type="number" size="small" v-model="ontherecharge" @input="ontherecharge=intNumber(ontherecharge)" placeholder="请输入内容"></el-input> --
            <el-input style="width:100px;" type="number" size="small" v-model="undertherecharge" @input="undertherecharge=intNumber(undertherecharge)" placeholder="请输入内容"></el-input>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="()=>{pageIndex=1;getlist();settleStatic();}">查询</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <div style=" margin-top: 20px;height:30px;background: #fff;padding: 5px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <!-- <el-button size="small" type="danger" @click.prevent="purge()">清除结算记录</el-button> -->
        <span class='tit' style="float: right;font-size: 14px;padding: 8px;">付款总金额：<span style="color:red;">{{totalMoney}}</span> 元 总手续费：<span style="color:red;">{{totalProfit}}</span> 元 </span>
      </div>
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="merchantId" label="商户ID" width="80">
        </el-table-column>
        <el-table-column prop="date" label="商户名/账号" width="110">
          <template slot-scope="scope">
            <p>{{scope.row.nickName}}</p>
            <p style="color:#666;">{{scope.row.account}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="applyDate" label="申请时间" width="160">
        </el-table-column>
        <el-table-column prop="serialNumber" label="流水号" width="178">
        </el-table-column>
        <el-table-column prop="realName" label="收款人">
        </el-table-column>
        <el-table-column prop="bankName" label="收款银行">
        </el-table-column>
        <el-table-column prop="bankNumber" label="收款账号">
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            <span style="color:green;font-weight:bold;">{{scope.row.amount.toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="手续费">
          <template slot-scope="scope">
            <span style="color:red;font-weight:bold;">{{scope.row.charge.toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述">
        </el-table-column>
        <el-table-column prop="completeDate" label="完成时间" width="160">
        </el-table-column>
        <el-table-column label="状态" width="85">
          <template slot-scope="scope">
            <span class="stateColor" :class="'color'+scope.row.state">{{scope.row.state|fstate}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time1: this.getCerentTime(true), // 开始时间
      time2: this.getCerentTime(false), // 开始时间
      tenantId: '', // 商户ID
      ontherecharge: '', // 充值金额上
      undertherecharge: '', // 充值金额下
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      totalMoney: 0.0, // 付款总金额
      totalProfit: 0.0, //  总手续费
      tableData: []
    };
  },
  filters: {
    fstate: function(data) {
      let state = '';
      switch (data) {
        case 0:
          state = '全部';
          break;
        case 1:
          state = '成功';
          break;
        case 2:
          state = '付款中';
          break;
        case 3:
          state = '审核中';
          break;
        case 4:
          state = '待付款';
          break;
        case 5:
          state = '审核失败';
          break;
        case 6:
          state = '拒绝付款';
          break;
      }
      return state;
    }
  },
  methods: {
    // 结算记录列表
    getlist() {
      this.$api.money
        .settleList({
          MerchantId: this.tenantId === '' ? 0 : this.tenantId,
          StartTime: this.time1 ? this.time1 : null,
          EndTime: this.time2 ? this.time2 : null,
          MinAmount: this.ontherecharge,
          MaxAmount: this.undertherecharge,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 结算记录统计
    settleStatic() {
      this.$api.money
        .settleStatic({
          MerchantId: this.tenantId === '' ? 0 : this.tenantId,
          StartTime: this.time1 ? this.time1 : null,
          EndTime: this.time2 ? this.time2 : null,
          MinAmount: this.ontherecharge,
          MaxAmount: this.undertherecharge,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 200) {
            this.totalMoney = data.data.totalAmount.toFixed(2);
            this.totalProfit = data.data.totalCharge.toFixed(2);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 清除结算记录
    clearRecod() {
      this.$api.money
        .clearRecod({
          MerchantId: this.tenantId === '' ? 0 : this.tenantId,
          StartTime: this.time1 ? this.time1 : null,
          EndTime: this.time2 ? this.time2 : null,
          MinAmount: this.ontherecharge,
          MaxAmount: this.undertherecharge,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('清除结算记录成功！');
            this.getlist();
            this.settleStatic();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 清除结算记录提示
    purge() {
      this.$confirm('是否确认清除该时间段的所有结算数据?')
        .then(() => {
          this.clearRecod();
        })
        .catch((_) => {});
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
      this.settleStatic();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
      this.settleStatic();
    }
  },
  created() {
    this.getlist();
    this.settleStatic();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.tableinfo {
  background: #fff;
  padding: 8px 20px;
  table {
    width: 100%;
    color: #272727;
    font-size: 14px;
    td {
      height: 30px;
    }
    .c_3fa396 {
      color: #3fa396;
    }
  }
}
.stateColor {
  display: inline-block;
  padding: 3px 5px;
  background: green;
  text-align: center;
  color: #fff;
  min-width: 50px;
  border-radius: 4px;
  &.color1 {
    background: green;
  }
  &.color2 {
    background: rgb(136, 209, 27);
  }
  &.color3 {
    background: rgb(14, 141, 130);
  }
  &.color4 {
    background: rgb(137, 47, 255);
  }
  &.color5 {
    background: #ccc;
  }
  &.color6 {
    background: rgb(47, 154, 255);
  }
}
</style>
